// Helpers for adding/removing class names that may be CSS-Module `composes:`
// values. CSS Modules compiles `composes:` into a whitespace-separated multi-token
// string ("classA classB"). classList.add/remove reject a whitespace-containing
// token with InvalidCharacterError, and classList.contains() silently returns
// false for it (so a contains-then-remove guard never fires on composed themes).
// Split on whitespace (the DOMTokenList separator) before touching it.

export const addComposedClasses = (el, classString) => {
	if (!el || !el.classList || !classString) return;
	classString.trim().split(/[\t\n\f\r ]+/).forEach((c) => c && el.classList.add(c));
};

export const removeComposedClasses = (el, classString) => {
	if (!el || !el.classList || !classString) return;
	classString.trim().split(/[\t\n\f\r ]+/).forEach((c) => c && el.classList.remove(c));
};
